export default {
  PROCESS_DATA(state, processing) {
    state.processing = processing
  },
  FEEDBACK_DATA(state, feedback) {
    state.feedback = feedback
  },
  FEEDTYPE_DATA(state, feedtype) {
    state.feedtype = feedtype
  },
  SET_THEME(state, theme) {
    state.theme = theme
    window.localStorage.setItem('theme', state.theme)
  },
  UPDATE_LAST_VISITED(state, timestamp) {
    state.last_visited = timestamp;
    window.localStorage.setItem('last_visited', state.last_visited)
  },
  SET_OWNER_ID(state, owner_id) {
    state.owner_id = owner_id;
    window.localStorage.setItem('owner_id', state.owner_id)
  },
  SET_CURRENT_LOCATION(state, current_location) {
    state.current_location = current_location;
    window.localStorage.setItem('current_location', JSON.stringify(state.current_location))
  },
  SET_TEMPORARY_LOCATION(state, selected_location) {
    state.selected_location = selected_location;
    window.localStorage.setItem('selected_location', JSON.stringify(state.selected_location))
  },
  SET_PARTNER(state, partner_id) {
    state.partner_id = partner_id;
    window.localStorage.setItem('partner_id', state.partner_id)
  },
  SET_CART(state, cart) {
    state.cart = cart;
    window.localStorage.setItem('cart', JSON.stringify(state.cart))
  },
  REMOVE_CART(state) {
    state.cart = [];
    window.localStorage.removeItem('cart')
  },
  SET_ONBOARDING_POINT(state, onboarding_point) {
    state.onboarding_point = onboarding_point;
    window.localStorage.setItem('onboarding_point', state.onboarding_point)
  },
  SET_NEW_SCANED_TAG(state, new_tag) {
    state.new_tag = new_tag;
    window.localStorage.setItem('tag_id', state.new_tag)
  },
  REMOVE_NEW_SCANED_TAG(state) {
    state.new_tag = '';
    window.localStorage.removeItem('tag_id')
  },
  SET_PETDATA(state, pet_data) {
    state.pet_data = pet_data
    window.localStorage.setItem('pet_page', JSON.stringify(state.pet_data))
  },
  REMOVE_PETDATA(state) {
    state.pet_data = {}
    window.localStorage.removeItem('pet_page')
  },
  REMOVE_OWNER_ID(state) {
    state.owner_id = '';
    window.localStorage.removeItem('owner_id')
  },
  SET_GALLERY(state, gallery) {
    state.current_gallery = gallery
    window.localStorage.setItem('pet_gallery',  JSON.stringify(state.current_gallery))
  },
  SET_USER_ID(state, userID) {
    state.userID = userID
    window.localStorage.setItem('uid', userID)
    state.auth = true;
  },
  LOGOUT(state) {
    state.userID = ''
    window.localStorage.removeItem('usertoken')
    window.localStorage.removeItem('uid')
    window.localStorage.removeItem('tag_id')
    window.localStorage.removeItem('pet_page')
    window.localStorage.removeItem('theme')
    window.localStorage.removeItem('new_connection')
    window.localStorage.removeItem('active_flyer')
  },
  AUTH_SUCCESS(state, token, userID) {
    state.userID = userID
    state.token = token
    state.auth = true;
  },
  AUTH_ERROR(state) {
    state.userID = '';
    state.token = ''
    state.auth = false;
  },
  LOADER(state, payload) {
    state.loader = payload;
  },
  AUTH_LOGOUT(state) {
    state.token = '';
    state.merchanttoken = '';
  },
  ALERT_CODE(state, alert_code, data){
    if(alert_code == 'new_connection'){
      state.new_connection = data;
    }else if(alert_code == 'max_file_upload'){
      state.max_file_upload = {length: data, error: 'max_file_upload', displayNotification: true};
    }else if(alert_code == 'max_file_size'){
      state.max_file_size = {length: data, error: 'max_file_size', displayNotification: true};
    }
    setTimeout(()=>{ this.commit('REMOVE_ALL_ALERTS'); }, 2000);
  },
  REMOVE_ALL_ALERTS(state){
    state.new_connection = {}
    state.max_file_upload = {}
    state.max_file_size = {}
    window.localStorage.removeItem('new_connection')
    window.localStorage.removeItem('max_file_upload')
    window.localStorage.removeItem('max_file_size')
  }
}
